import React from "react";
import { useTranslation } from "react-i18next";
import img1 from '../../assets/new images/scholarship1.png';
import img2 from '../../assets/new images/scholarship2.png';
import img3 from '../../assets/new images/scholarship3.png';
const Scholarship = () => {
  const { t } = useTranslation();
  // NOTE: pre-existing typo in original English copy ("Duition" -> "Tuition") preserved verbatim in scholarshipSection.desc2 to avoid changing displayed text.
  const features = [
  {
    title: t("scholarshipSection.title1"),
    desc: t("scholarshipSection.desc1"),
    icon: img1,
  },
  {
    title: t("scholarshipSection.title2"),
    desc: t("scholarshipSection.desc2"),
    icon: img2,
  },
  {
    title: t("scholarshipSection.title3"),
    desc: t("scholarshipSection.desc3"),
    icon: img3,
  },
];
  return (
  <section className="py-20 bg-gray-50 text-center">
    <h2 className="text-5xl font-bold text-gray-800 mb-8">{t("scholarshipSection.titleLine1")}<br /> {t("scholarshipSection.titleLine2")}</h2>
    <p className="max-w-2xl mx-auto text-center text-gray-600 mb-12">
     {t("scholarshipSection.subtitleLine1")}<br />  {t("scholarshipSection.subtitleLine2")} <br /> {t("scholarshipSection.subtitleLine3")}
    </p>
    <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
      {features.map((f, i) => (
        <div key={i} className="bg-white flex flex-col gap-2 justify-center items-center p-8 shadow rounded-xl">
                   <div className="bg-[#EE5F2B1A]/10 p-4 rounded-xl mb-4">
          <img src={f.icon} alt="" className="w-8 h-8"/>
          </div>
          <h3 className="font-semibold text-xl mb-2">{f.title}</h3>
          <p className="text-gray-600 ">{f.desc}</p>
        </div>
      ))}
    </div>
  </section>
  );
};

export default Scholarship;
